<style>
.pagination-wrapper{
  display:flex;
  justify-content:center;
  align-items:center;
  gap:6px;
  margin-top:20px;
  margin-bottom: 20px;
  flex-wrap:wrap;
}

.pagination-wrapper button{
  border:none;
  background:#2c3e50;
  color:white;
  padding:3px 10px;
  border-radius:5px;
  cursor:pointer;
  font-size: 14px;
}

.pagination-wrapper button.active{
  background:#197fe6;
}

.pagination-wrapper button:disabled{
  opacity:0.5;
  cursor:not-allowed;
}

/**price card************** */
  .price-card {
    cursor: pointer;
    display: block;
    /*transition: 0.3s ease;*/
    position: relative;
    background: #fff;
  }

  /* hide radio */
  .price-card input {
    display: none;
  }

  .price-inner{
     border: 1px solid #E5E7EB;
    border-radius: 6px;
    padding: 4px 10px;
  }

   /* ACTIVE STATE */
  .price-card input:checked+.price-inner {
    /*border-top: 1px solid #22C55E;*/
  }

  .price-card input:checked~.price-inner,
  .price-card input:checked+.price-inner {
    /*border-top: 1px solid #22C55E;*/
  }

  .price-card input:checked+.price-inner .discount-price {
    color: #22C55E;
  }



  /* Alternative clean active style */
  .price-card input:checked+.price-inner {
    margin-top: -4px;
  }

  .price-card input:checked~.price-inner,
  .price-card input:checked+.price-inner {
    outline: 2px solid #22C55E;
    border-color: #22C55E;
  }

  .staff-cancel{
    outline: 1px solid #c52222 !important;
    border-color: #c52222 !important;
    border: 10px;
    background-color: #E5E7EB;
  }
tr.cancel-twise-2 td{
   background-color: #ffcccc !important;
}


</style>
<template>
    

      <!-- Content -->
      <div class="admin-content">

                <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">
  <!-- Left -->
  <div>
    <h5 class="mb-0 fw-semibold text-color">Cancel Orders</h5>
    <p class="mb-0 text-muted small">
      Manage Canceled Order's
    </p>
  </div>
  <!-- Right -->
 
</div>

      <div v-if="user.role == 1" class="row">
      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-primary">Cancel To Day's</p>
              <p class="card-big-p text-color"> 
                 <PriceFormat :Price="dataz.cancel_day"/>
              </p>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-danger">Cancel Last 7 Day's</p>
              <p class="card-big-p text-color">
                 <PriceFormat :Price="dataz.cancel_7day"/>
              </p>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-green">Cancel Last 30 Day's</p>
              <p class="card-big-p text-color">
                 <PriceFormat :Price="dataz.cancel_30day"/>
              </p>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-orange">Cancel Lifetime</p>
              <p class="card-big-p text-color">
                <PriceFormat :Price="dataz.cancel_life"/>
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>

        <div class="row align-items-stretch">
          <div class="col-md-12 col-sm-12 grid-col">

            <div class="product-filter-bar d-flex justify-content-between align-items-center flex-wrap gap-3 mob-mt">

  <!-- Left: Search -->
  <div class="filter-search d-flex">
    <input
      type="text"
       v-model="this.search_order"
      class="filter-search-input"
      placeholder="Search sales..."
    />
    <button class="filter-search-btn">
      <i class="fas fa-search"></i>
    </button>
  </div>

  <div v-if="searching" class="mt-1">
      <div class="text-center">
        <div class="spinner-grow text-success" role="status"></div>
        <div class="spinner-grow text-danger" role="status"></div>
        <div class="spinner-grow text-warning" role="status"></div>
      </div>
    </div>
  <!-- Right: Filters -->
  <div class="filter-actions d-flex align-items-center gap-2 mob-grid">
     <input
      type="date"
      v-model="this.sdate"
      class="filter-date-input"
    />
     <input
      type="date"
      v-model="this.edate"
      class="filter-date-input"
    />
  
    <button @click="getCancelFilter()" class="btn-primary">
      <i class="fas fa-filter me-1"></i>
      Filter
    </button>
  </div>
</div>

            <div class="card recent-orders-card mt-3">

              <!-- Card Header -->
              <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0 fw-semibold">
                  <span class="text-color">Recent Sales</span>
                </h5>
                <!--button class="btn-transparent text-primary text-sm">
                    <span class="fas fa-download"></span> Export
                </button-->
              </div>

              <!-- Card Body -->
             <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table orders-table mb-0">
                <thead class="">
                  <tr>
                    <th class="">ORDER ID</th>
                    <th class="td-wd-user">CLIENT</th>
                     <th class="">CONTACTS</th>
                   
                    <th class="td-wd-product">SUMMARY</th>
                    <th class="">TOTAL</th>
                     <th class="">ORDER-DATE</th>
                   <th class="">CANCEL-DATE</th>
                    <th v-if="user.role == 1" class="td-wd-sm">CANCEL BY</th>
                     <th v-if="user.role > 1" class="td-wd">LOCATION</th>
                      <th class="text-end">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  <tr :class="'cancel-twise-'+order.cancel" v-for="order in paginatedProducts" :key="order.id">
                    <td class="text-primary text-sm text-bold">#{{ order.id }}</td>
                    <td class="text-sm">
                      <UserAvatar v-if="order.avator == 'user.jpg'" :fullName="order.fulname" imageUrl="" />
                      <UserAvatar v-else :fullName="order.fulname" :imageUrl="this.$store.state.img_url + order.avator" />
                    </td>
                     <td class="text-color text-sm text-bold">
                       <PhoneFormat :Phone="order.contacts"/>
                     </td>
                  
                    <td class="text-color text-sm text-muted text-capitalize">({{ order.quantity }}) {{ order.summary  }}</td>
                    <td class="text-color text-sm text-bold">
                      <PriceFormat :Price="order.total"/>
                    </td>
                      <td class="text-muted text-sm">
                        <DateFormat :Date_="order.created_at"/>
                      </td>
                    <td class="text-primary fw-semibold">
                      <DateFormat :Date_="order.sale_at"/>
                    </td>
                    <td class=" fw-semibold text-muted text-sm">
                      <span>
                        {{ order.staff }}
                      </span>

                    </td>
                    <td  v-if="user.role > 1" class="text-color text-sm text-bold">{{ order.order_location }}</td>
                    <td class="text-end text-md">
                            <div class="order-actions">
                              <button @click="addConfirmModel(order)" data-bs-toggle="modal" data-bs-target="#addConfirm" class="order-action-btn text-primary edit" title="Edit">
                                <i class="fas fa-eye"></i> Details
                              </button>
                             
                            </div>
                          </td>
                  </tr>

                </tbody>
              </table>
            </div>
  
           <div class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
          </div>
            </div>


          </div>
         
        </div>

          <!--manual enter status-->
    <div class="modal fade" id="addConfirm" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">

      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content custom-modal-style">

          <!-- HEADER -->
          <div class="modal-header custom-modal-header d-flex justify-content-between align-items-center">

            <h5 class="modal-title mb-0">Order Details</h5>
            <button type="button" class="btn-close ms-3 text-white fas fa-xmark" data-bs-dismiss="modal">
            </button>
          </div>

          <!-- BODY -->
          <div class="modal-body custom-modal-body">
            <div class="row">
               <div class="col-sm-12 col-md-6">
                <img :src="this.$store.state.img_url + order.thumbnail" width="100%" height="auto" alt="">
               </div>
               <div class="col-sm-12 col-md-6">
                 <p class="mb-2 text-color"><i>Order ID : #{{ order.id }}</i></p>
                 <p class="mb-0 text-muted text-capitalize">Fullname : {{ order.fulname }}</p>
                 <p class="mb-0 text-muted">Phone No : {{ order.contacts }}</p>
                 <p class="mb-0 text-muted">Location : {{ order.order_location }}</p>
                 <p class="mb-0 text-muted">Quantity : {{ order.quantity }}</p>
                 <p class="mb-0 text-muted">Price : {{ order.total }}</p>
                 <p class="mb-0 text-color text-capitalize">{{ order.summary  }}, </p>
                 <p class="mb-0 text-muted text-sm">{{ order.created_at  }}, </p>
               </div>

               <div class="col-12">
                <div v-if="order.cancel < 2">
                 <p class="mt-3">Choose staff Below to Assign this Cancelled Order</p>
                  <div class="row mt-3">
                    <div class="col-md-4 col-sm-6" v-for="staff in staffs">
                       <label v-if="staff.id == order.staff_id" class="price-card staff-cancel">
                  <input type="radio" disabled="true" name="priceOption">

                  <div class="price-inner">
                     <span>{{ staff.username }}</span>
                  </div>
                </label>
                   <label v-else class="price-card">
                  <input type="radio" v-on:change="assignStaff(staff)" name="priceOption" :value="staff.id">

                  <div class="price-inner">
                     <span>{{ staff.username }}</span>
                  </div>
                </label>
                    </div>
                  </div>
                  <button type="button" @click="assignStaffOrder" class="btn-primary font-bold mt-3">
                  <i class="fas fa-check me-2"></i>
                  Assign {{ assign_staff_name }}
                </button>
              </div>
              <div v-else>
                <p class="mt-3 text-danger">This Order Cancelled Twise</p>
              </div>
               </div>
            </div>

            <!--foradmin-->
              <div class="mt-3">
                <div v-if="searching" class="mt-1">
      <div class="text-center">
        <div class="spinner-grow text-success" role="status"></div>
        <div class="spinner-grow text-danger" role="status"></div>
        <div class="spinner-grow text-warning" role="status"></div>
      </div>
    </div>

     <div class="table-responsive">
              <table class="table orders-table mb-0">
                <thead class="">
                  <tr>
                   
                   
                   <th class="">PROCESS</th>
                    <th class="td-wd-sm">PROCESS BY</th>
                     <th class="">COMMENT</th>
                      <th class="text-end td-wd">ISSUE-DATE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="pros in order_process" :key="order.id">
                 <td> <OrderStatus :statusName="pros.status_name" :statusID="pros.status_id" /></td>
                      <td class=" fw-semibold text-muted text-sm">
                      <span>
                        {{ pros.staff }}
                      </span>

                    </td>
                    <td class="text-muted text-sm">{{ pros.comment }}</td>
                  
                   
                    <td class="text-color text-end text-bold"> <DateFormat :Date_="pros.created_at"/></td>
                  
                  </tr>

                </tbody>
              </table>
            </div>


              </div>
        
          </div>
        </div>
      </div>
    </div>
      </div>
</template>

<script>
import axios from "axios";

import { createToast } from "mosha-vue-toastify"
import "mosha-vue-toastify/dist/style.css"

import UserAvatar from "@/components/UserAvatar.vue";
import OrderStatus from "@/components/OrderStatus.vue";
import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";
import Order from "./Order.vue";

export default {
  components: {
    UserAvatar,
    OrderStatus,
    PriceFormat,
    PhoneFormat,
    DateFormat
  },
  data() {
    return {
      searching: false,
      errors: "",
      data: [],
      tags:[],
      dataz:{},
      order:{},
      orders:[],
      og_orders:[],
      staffs:[],
      assign_staff_id : 0,
      assign_staff_name : "",
      selectedStatus:0,
      order_status:[],
      order_process:[],
      search_order:"",
      currentPage: 1,
      perPage: 10,
      sdate:"",
      edate:"",
      user:this.$attrs.user
    };
  },
  methods: {
          async getStaffs() {
      var response = await axios
        .post(this.$store.state.api_url + "/get-staffs",{type:"sales"})
        .catch((errors) => {
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {
        this.staffs = response.data.staffs;
      
      } else {
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
      assignStaff(staff){

        this.assign_staff_id = staff.id
        this.assign_staff_name = staff.username
       
    },
      async assignStaffOrder(){

        var staff_name = this.assign_staff_name

          const confirmAssign = window.confirm(
        'Are you sure you want to Assign '+staff_name+'?'
      );

      if (!confirmAssign) {
        //window.location.reload()
        return
      }else{

      var status = 2
      var order_id = this.order.id
      var sale_by = this.assign_staff_id
      var comment = ""
     
      // update status 

      await this.updateStatus(status, order_id, sale_by, comment)
      }
       
    },
      async updateStatus(status, order_id, sale_by, comment){

         var response = await axios.post(this.$store.state.api_url + "/update-order-status",{status, order_id, sale_by, comment})
      .catch((errors) => {
        var message = "Network or Request Errors";
        alert(message)
        //this.$toast.error(message, { duration:5000, dismissible: true });
      });
      if (response.data.success) {
       // alert('Cuccessfully')

        window.location.reload()
      } else {
        alert(response.data.message)
      }
    },
      async cancelDatas() {
      var response = await axios
        .get(this.$store.state.api_url + "/cancel-datas")
        .catch((errors) => {
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });

      console.log(response.data)
      if (response.data.success) {

        this.dataz = response.data.dataz;
       

      } else {
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
     
      async getCancelOrders() {

        this.searching = true
      var response = await axios
        .post(this.$store.state.api_url + "/get-cancel-orders",{limit:50})
        .catch((errors) => {
           this.searching = false
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {
         this.searching = false
        this.orders = response.data.orders;
        this.og_orders = response.data.orders;
      
      } else {
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },

      async getCancelFilter() {

      this.searching = true

      var sdate = this.sdate
      var edate = this.edate

      var response = await axios
        .post(this.$store.state.api_url + "/get-cancel-filter",{sdate, edate})
        .catch((errors) => {
           this.searching = false
          var message = "Network or Server Errors";
         this.$toast.error(message, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {
          this.searching = false
        this.orders = response.data.orders;
        this.og_orders = response.data.orders;
      
      } else {
         this.searching = false
          var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
       
        //alert(response.data.message)
      }

    },
    async addConfirmModel(order){
       this.order = order

       var order_id = order.id

        var response = await axios
        .post(this.$store.state.api_url + "/get-order-process",{order_id})
        .catch((errors) => {
           this.searching = false
          var message = "Network or Server Errors";
         this.$toast.error(message, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {
          this.searching = false
        this.order_process = response.data.order_process;
       
      
      } else {
         this.searching = false
          var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
}   
    },
   
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  }

  },
  computed: {

  paginatedProducts() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.orders.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.orders.length / this.perPage)
  },
  

},
watch: {
  search_order(value) {

    let term = value.toLowerCase().trim()

    if(!term){
      this.orders = this.og_orders
      return
    }

    this.orders = this.og_orders.filter(order => {

      return (
        (order.summary && order.summary.toLowerCase().includes(term)) ||
        (order.contacts && order.contacts.toLowerCase().includes(term)) ||
        (order.id && order.id.toString().includes(term)) ||
        (order.order_location && order.order_location.toLowerCase().includes(term)) ||
        (order.fulname && order.fulname.toLowerCase().includes(term))
      )

    })

  }
},
  created() {
    this.$store.state.page_name = "Cancelation" 
    this.cancelDatas()
    this.getCancelOrders()
    this.getStaffs()
  },
};
</script>
